import {
    Module,
    VuexModule,
    Mutation,
    Action,
    getModule,
} from 'vuex-module-decorators';
import store from '~common-store';
import { PopupState } from '~common-interfaces/popup.interface';

@Module({ dynamic: true, store, name: 'popup', namespaced: true })
class Popup extends VuexModule implements PopupState {
    popupHistory: string[] = [];
    currentIndexInHistory = -1;
    filterValue = '';
    filterIncludesValue = true;
    lastExecuted: Date = {} as Date;

    get popupRequested() {
        return this.popupHistory[this.currentIndexInHistory] || '';
    }

    get isPopupRequested() {
        return this.popupRequested !== '';
    }

    get previousPopupExists() {
        return this.currentIndexInHistory > 0;
    }

    get nextPopupExists() {
        return this.currentIndexInHistory < this.popupHistory.length - 1;
    }

    @Mutation
    PUSH_POPUP_HISTORY(popupRequested: string) {
        const nbOfItemsToRemove = this.popupHistory.length - this.currentIndexInHistory;
        // overwrite the content of the history after the current index
        this.popupHistory.splice(this.currentIndexInHistory, nbOfItemsToRemove, popupRequested);

    }

    @Mutation
    RESET_POPUP_HISTORY() {
        this.popupHistory = [];
        this.currentIndexInHistory = -1;
    }

    @Mutation
    UPDATE_INDEX(operation: string) {
        switch (operation) {
            case 'increment':
                this.currentIndexInHistory++;
                break;
            case 'decrement':
                this.currentIndexInHistory--;
                break;
            default:
                break;
        }
    }

    @Mutation
    SET_FILTER_VALUE(val: string) {
        this.filterValue = val;
    }

    @Mutation
    SET_FILTER_INCLUDES_VALUE(val: boolean) {
        this.filterIncludesValue = val;
    }

    @Mutation
    SET_LAST_EXECUTED(val: Date) {
        this.lastExecuted = val;
    }

    @Action
    setPopupRequested(popupRequested: string) {
        this.context.commit('UPDATE_INDEX', 'increment');
        this.context.commit('PUSH_POPUP_HISTORY', popupRequested);
    }

    @Action
    goBackHistory() {
        this.context.commit('UPDATE_INDEX', 'decrement');
    }

    @Action
    goForwardHistory() {
        this.context.commit('UPDATE_INDEX', 'increment');
    }

    @Action
    setPopupInactive() {
        this.context.commit('RESET_POPUP_HISTORY');
        this.resetFilter();
        this.setLastExecuted({} as Date);
    }

    @Action
    resetFilter() {
        this.setFilterValue('');
        this.setFilterIncludesValue(true);
    }

    @Action({ commit: 'SET_FILTER_VALUE' })
    setFilterValue(val: string) {
        return val;
    }

    @Action({ commit: 'SET_FILTER_INCLUDES_VALUE' })
    setFilterIncludesValue(val: boolean) {
        return val;
    }

    @Action({ commit: 'SET_LAST_EXECUTED' })
    setLastExecuted(val: Date) {
        return val;
    }


}

export const PopupModule = getModule(Popup);
